import { useClientMarketingConsent } from '@/hooks';
import { Checkbox, useConfig } from '@travelwin/core';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

interface MarketingConsentCheckboxGroupProps {
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleClientMarketingChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => void;
  values: {
    promo_optin: boolean;
    client_promo_optin?: boolean;
  };
}

const MarketingConsentCheckboxGroup: React.FC<
  MarketingConsentCheckboxGroupProps
> = ({ handleChange, values, handleClientMarketingChange }) => {
  const { t } = useTranslation();
  const { MARKETING_ENABLED, CLIENT_MARKETING_CONSENT, BRAND_NAME } =
    useConfig();
  const { clientMarketingConsent } = useClientMarketingConsent();

  if (!MARKETING_ENABLED) {
    return null;
  }

  return (
    <div className="flex flex-column gap-4">
      <Checkbox
        data-testid="checkbox-promo-optin"
        name="promo_optin"
        value="promo_optin"
        onChange={handleChange}
        checked={values.promo_optin}
      >
        <Trans
          i18nKey="form.promo_optin_line1"
          defaults="Email me with special offers and news from {{brand}}."
          values={{ brand: BRAND_NAME }}
        />
      </Checkbox>

      {CLIENT_MARKETING_CONSENT &&
        clientMarketingConsent?.enabled &&
        handleClientMarketingChange && (
          <Checkbox
            name="client_promo_optin"
            value="client_promo_optin"
            onChange={handleClientMarketingChange}
            checked={values.client_promo_optin}
          >
            {t(
              'form.promo_option_heathrow',
              'Tick here to receive marketing communications, promotions, news, competitions, updates and more from Heathrow Airport Limited and Heathrow Express Operating Company Limited. You will only receive marketing communication directly from Heathrow, including information about Heathrow’s Business Partners who operate on and off the airport.',
            )}
          </Checkbox>
        )}
    </div>
  );
};

export default MarketingConsentCheckboxGroup;
